module.exports = __webpack_public_path__ + "img/0b3d7b2.svg";